module.exports = __webpack_public_path__ + "static/media/gwen-stacy-icon.97843d24.png";